/* ============================================================================
 * QrCode — renders a real, scannable QR from a string.
 * Uses `qrcode` (canvas → data URL). Kept as a component so the Presence
 * station can swap in an SVG or a canvas renderer without touching the app.
 * ========================================================================= */

import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface Props {
  value: string;
  size?: number;
  alt?: string;
}

export function QrCode({ value, size = 132, alt = 'QR code' }: Props) {
  const [src, setSrc] = useState<string>('');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: size,
      color: { dark: '#0a1330', light: '#f4ecd8' },
    })
      .then((url) => {
        if (!cancelled) {
          setSrc(url);
          setErr(null);
        }
      })
      .catch((e: unknown) => {
        if (!cancelled) setErr(e instanceof Error ? e.message : String(e));
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (err) {
    return (
      <div className="qr" style={{ display: 'grid', placeItems: 'center' }}>
        <span className="tag tag--err">QR ERROR</span>
      </div>
    );
  }

  return (
    <img className="qr" src={src} width={size} height={size} alt={alt} />
  );
}
